import * as React from "react";
import { Text } from "../CustomStyleComponents/StyledComponents";
import Base from "../CustomStyleComponents/Base";

const Loading = () => {
  return <Base mainText={<Text>Loading...</Text>} />;
};

export default Loading;
